import {
    ACCOUNT,
    ACCOUNT_NS,
    CATEGORIES_NS,
    CONFIGURATION,
    EMPLOYEES,
    EMPLOYEES_NS,
    MENU_NS,
    PRODUCTS,
    PRODUCTS_NS,
    PRODUCT_CATEGORIES,
    STORE_CLOSING,
    STORE_CLOSING_NS,
    STORE_CONFIG_NS,
    TABLES,
    TABLES_NS,
    USER_NS
} from '../Constants';
import { ImageType } from '../types';

// TODO: check field widths
const DE_TRANSLATION = {
    required_field: 'Pflicht Feld',
    save: 'SPEICHERN',
    delete: 'LÖSCHEN',
    cancel: 'ABBRECHEN',
    username: 'BENUTZERNAME',
    password: 'KENNWORT',
    error: 'Fehler',
    [`${ACCOUNT_NS}.password_mismatch`]: 'Die Kennwörter stimmen nicht zusammen',
    [`${ACCOUNT_NS}.repeat_password`]: 'KENNWORT BESTÄTIGUNG',
    [`${ACCOUNT_NS}.successful_update`]: 'Das Kennwort würde erfolgreich geändert',
    [`${CATEGORIES_NS}.name`]: 'NAME',
    [`${CATEGORIES_NS}.icon`]: 'SYMBOL',
    [`${EMPLOYEES_NS}.name`]: 'NAME',
    [`${EMPLOYEES_NS}.phone`]: 'TELEFONNUMMER',
    [`${USER_NS}.logged_user`]: 'ANGEMELDETER BENUTZER',
    [`${MENU_NS}.product_categories`]: 'Produktkategorien',
    [`${MENU_NS}.products`]: 'Produkte',
    [`${MENU_NS}.tables`]: 'Tische',
    [`${MENU_NS}.employees`]: 'Mitarbeiter',
    [`${MENU_NS}.store_configuration`]: 'Filialeeinstellungen',
    [`${MENU_NS}.account_configuration`]: 'Kontoeinstellungen',
    [`${MENU_NS}.store_closing`]: 'Lokal Öffnungszeiten Schließung',
    [`${PRODUCTS_NS}.price_validation`]:
        'Der Preis muss auf null sein, wenn eine Variante hinzugefügt ist',
    [`${PRODUCTS_NS}.variety_validation`]: 'Nur eine vorgegebene Variante ist erlaubt',
    [`${PRODUCTS_NS}.name`]: 'NAME',
    [`${PRODUCTS_NS}.description`]: 'BESCHREIBUNG',
    [`${PRODUCTS_NS}.category`]: 'KATEGORIE',
    [`${PRODUCTS_NS}.price`]: 'PREIS',
    [`${PRODUCTS_NS}.varieties`]: 'VARIANTEN',
    [`${PRODUCTS_NS}.add_variety`]: 'Neue Variante hinzufügen',
    [`${PRODUCTS_NS}.remove_variety`]: 'Variante löschen',
    [`${PRODUCTS_NS}.default_variety`]: 'VOREINSTELLUNG',
    [`${PRODUCTS_NS}.variety_name`]: 'Name',
    [`${PRODUCTS_NS}.variety_price`]: 'Preis',
    [`${PRODUCTS_NS}.delete_product`]: 'Produkt löschen',
    [`${PRODUCTS_NS}.delete_product_confirm`]:
        'Sind Sie sicher dass Sie das Produkt "{{id}} - {{name}}" löschen wollen? Diese Aktion ist unumkehrbar!',
    [`${STORE_CONFIG_NS}.languages_validation`]:
        'Es muss zumindest eine Sprache ausgewählt sein',
    [`${STORE_CONFIG_NS}.default_lang_ui_validation`]:
        'Diese Sprache ist in der Liste der gewünschten Sprachen nicht ausgewählt',
    [`${STORE_CONFIG_NS}.card_payment`]: 'MIT KARTE ZAHLEN',
    [`${STORE_CONFIG_NS}.pos_devices`]: 'ANZAHL POS GERÄTEN',
    [`${STORE_CONFIG_NS}.pos_movable`]: 'TRAGBARES POS-GERÄT',
    [`${STORE_CONFIG_NS}.free_wifi`]: 'GRATIS WIFI VORHANDEN',
    [`${STORE_CONFIG_NS}.customer_ordering`]: 'MÖGLICHKEIT DER KUNDENBESTELLUNG',
    [`${STORE_CONFIG_NS}.geolocation`]: 'SICHERHEIT DURCH GEOLOGATION',
    [`${STORE_CONFIG_NS}.authentication`]: '2-FAKTOR-AUTHENTIFIZIERUNG',
    [`${STORE_CONFIG_NS}.logo`]: 'LOGO VORHANDEN',
    [`${STORE_CONFIG_NS}.languages`]: 'GEWÜNSCHTE SPRACHEN',
    [`${STORE_CONFIG_NS}.ui_lang`]: 'HAUPT ANZEIGESPRACHE',
    [`${STORE_CONFIG_NS}.menu_lang`]: 'HAUPT MENUSPRACHE',
    [`${STORE_CONFIG_NS}.people_table`]: 'ANZAHL PERSONEN PRO TISCH',
    [`${STORE_CONFIG_NS}.missing_logo`]: 'Sie müssen zuerst eine Logo-Datei auswählen',
    [`${STORE_CONFIG_NS}.upload_logo_error`]:
        'Ein Fehler ist passiert während des Logo-Datei Hochladens',
    [`${TABLES_NS}.table_code_validation`]: 'Nur bis 5 Zeichen sind erlaubt',
    [`${TABLES_NS}.print_dimensions`]: 'DRUCK FORMAT',
    [`${TABLES_NS}.print_title`]: 'TISCH PDF-DATEI GENERIERUNG',
    [`${TABLES_NS}.print_languages`]: 'DRUCKSPRACHEN',
    [`${TABLES_NS}.pdf_file`]: 'TISCHAUSWAHL',
    [`${TABLES_NS}.pdf_current_table`]: 'EINER TISCH (AKTUELL)',
    [`${TABLES_NS}.pdf_all_tables`]: 'ALLE TISCHE',
    [`${TABLES_NS}.pdf_create`]: 'PDF-DATEI GENERIERUNG',
    [`${TABLES_NS}.pdf_create_info`]:
        'NACH DEM ABSCHLUSS WIRD EINE .ZIP-DATEI AN DIE VOM BENUTZER ANGEGEBENE E-MAIL GESENDET',
    [`${TABLES_NS}.table_code`]: 'KURZZEICHEN',
    [`${TABLES_NS}.table_description`]: 'BESCHREIBUNG',
    [`${TABLES_NS}.table_seats`]: 'SITZPLÄTZE',
    [`${TABLES_NS}.table_added`]: 'Der Tisch "{{code}}" würde angelegt',
    [`${TABLES_NS}.table_updated`]:
        'Der Tisch "{{code}}" würde erfolgreich gespeichert',
    [`${TABLES_NS}.max_lang_selection`]:
        'Für das Druckformat A7 light, können Sie bis 2 Sprachen auswählen',
    [`${TABLES_NS}.lang_selection_validation`]:
        'Für dieses Druckformat, können Sie nur eine Sprache auswählen',
    [`${STORE_CLOSING_NS}.delete_closure`]: 'Schließungseintrag Löschen',
    [`${STORE_CLOSING_NS}.delete_closure_confirm`]:
        'Sind Sie sicher, dass Sie den Schließung Eintrag "{{id}} - {{shortDescription}}" löschen wollen? Diese Aktion ist unumkehrbar!',
    [`${STORE_CLOSING_NS}.message.label`]: 'ANZEIGEMELDUNG',
    [`${STORE_CLOSING_NS}.message.displayFrom`]: 'MELDUNG ANZEIGEN VON',
    [`${STORE_CLOSING_NS}.from`]: 'VON',
    [`${STORE_CLOSING_NS}.to`]: 'BIS',
    [`${STORE_CLOSING_NS}.description.label`]: 'KURZBESCHREIBUNG',
    [`${STORE_CLOSING_NS}.form.invalid_display_date`]:
        'Das Anzeige Datum kann nicht später von dem VON Datum sein',
    [`${STORE_CLOSING_NS}.form.invalid_range`]:
        'Das VON Datum kann nicht nachher des BIS Datums sein',
    [`${PRODUCT_CATEGORIES}`]: 'PRODUKTKATEGORIEN',
    [`${PRODUCTS}`]: 'PRODUKTE',
    [`${EMPLOYEES}`]: 'MITARBEITER',
    [`${TABLES}`]: 'FILIALE-TISCHE',
    [`${CONFIGURATION}`]: 'FILIALE-EINSTELLUNGEN',
    [`${ACCOUNT}`]: 'KONTO-EINSTELLUNGEN',
    [`${STORE_CLOSING}`]: 'LOKAL ÖFFNUNGSZEITEN SCHLIESSUNG',
    [ImageType.BEER]: 'Bier',
    [ImageType.BEVERAGE]: 'Kaltgetränke',
    [ImageType.BREAKFAST]: 'Frühstück',
    [ImageType.BURGER]: 'Burgers',
    [ImageType.COCTAIL]: 'Cocktails',
    [ImageType.COFFEE]: 'Kaffee',
    [ImageType.FOOD]: 'Essen',
    [ImageType.ICE_CREAM]: 'Eis',
    [ImageType.SWEETS]: 'Süßwaren',
    [ImageType.WINE]: 'Weine',
    [ImageType.FISH]: 'Fisch',
    [ImageType.MEAT]: 'Fleish',
    [ImageType.PIZZA]: 'Pizza',
    [`${EMPLOYEES_NS}.invalid_email`]: 'Die Email Adresse ist nicht gültig',
    [`${STORE_CLOSING_NS}.success`]:
        'Die Öffnungszeiten wurden erfolgreich aktualisiert'
};

export default DE_TRANSLATION;
